import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { StorageService } from "./storage.service";
import {
  LOGIN_TOKEN,
  USR_PROFILE,
  USR_MENU,
  MICROSOFT_TOKEN,
} from "~common/config/constants";
import { MsalService } from "@azure/msal-angular";
import {
  AuthenticationResult,
  AccountInfo,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
import jwt_decode from "jwt-decode";
@Injectable({
  providedIn: "root",
})
export class AuthenticationService extends BaseService {
  constructor(
    http: HttpClient,
    private storageService: StorageService,
    private msalService: MsalService
  ) {
    super(http);
  }

  private redirectUrl: string;

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  getRedirectUrl() {
    return this.redirectUrl || null;
  }

  public isAuthenticated(): boolean {
    const token = this.getToken();
    const microsoftToken = this.getMicrosoftToken();
    if (
      token != "" &&
      token != null &&
      microsoftToken != "" &&
      microsoftToken != null
    ) {
      try {
        // Decode token
        const decodedToken: any = jwt_decode(token);
        const decodedMicrosoftToken: any = jwt_decode(microsoftToken);

        // Check token expiry
        const isExpired: boolean = Date.now() >= decodedToken.exp * 1000;
        const isMicrosoftExpired: boolean =
          Date.now() >= decodedMicrosoftToken.exp * 1000;
        if (isExpired || isMicrosoftExpired) {
          localStorage.clear();
        }
        return !isExpired;
      } catch (err) {
        console.log("Invalid token", err);
        return false;
      }
    }

    return false;
  }

  async login(param: any): Promise<any> {
    const loginReq = {
      email: param.email,
    };
    const result = await this.post(`auth/login`, loginReq);
    return result;
  }

  async me(): Promise<any> {
    let result = await this.get(`user/me`);
    return result;
  }

  async saveUserMenus(menuId: string) {
    const result = await this.get(`user/menu?menu_id=${menuId}`);

    const { isSuccess, payload } = result;

    if (!isSuccess) {
      return;
    }

    this.storageService.setDataSession(USR_MENU, payload ?? "");
  }

  getUserMenus(): any {
    return this.storageService.getDataSession(USR_MENU);
  }

  saveToken(token: string): void {
    this.storageService.setDataSession(LOGIN_TOKEN, token);
  }

  saveMicrosoftToken(token: string): void {
    this.storageService.setDataSession(MICROSOFT_TOKEN, token);
  }

  saveProfile(value: any): void {
    this.storageService.setDataSession(USR_PROFILE, value);
  }

  getToken() {
    return this.storageService.getDataSession(LOGIN_TOKEN);
  }

  getMicrosoftToken() {
    return this.storageService.getDataSession(MICROSOFT_TOKEN);
  }

  getProfile(): any {
    return this.storageService.getDataSession(USR_PROFILE);
  }
}
